import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const OpportunityCard = ({ opportunities }) => {
  const navigate = useNavigate();

  const getSkillBadgeColor = (skill) => {
    const colors = {
      'Marketing': 'bg-blue-100 text-blue-700',
      'Teaching': 'bg-green-100 text-green-700',
      'Technology': 'bg-purple-100 text-purple-700',
      'Healthcare': 'bg-red-100 text-red-700',
      'Design': 'bg-pink-100 text-pink-700',
      'Management': 'bg-amber-100 text-amber-700'
    };
    return colors?.[skill] || 'bg-gray-100 text-gray-700';
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-md border border-border">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
          <Icon name="Sparkles" size={24} className="text-accent" />
          Recommended For You
        </h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/smart-opportunity-finder')}
          iconName="ArrowRight"
          iconPosition="right"
        >
          View All
        </Button>
      </div>
      <div className="space-y-4">
        {opportunities?.map((opportunity) => (
          <div
            key={opportunity?.id}
            className="flex flex-col sm:flex-row gap-4 p-4 rounded-lg border border-border hover:border-primary hover:shadow-md transition-all cursor-pointer group"
            onClick={() => navigate('/smart-opportunity-finder')}
          >
            <div className="flex-shrink-0 w-full sm:w-20 h-20 rounded-lg overflow-hidden bg-muted">
              <Image
                src={opportunity?.organizationLogo}
                alt={opportunity?.organizationLogoAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-2">
                <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors line-clamp-1">
                  {opportunity?.title}
                </h3>
                <span className="flex-shrink-0 text-xs font-medium text-accent bg-accent/10 px-2 py-1 rounded-full">
                  {opportunity?.matchScore}% Match
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-2 line-clamp-1">
                {opportunity?.organization}
              </p>
              <div className="flex flex-wrap items-center gap-2 mb-2">
                <span className="flex items-center gap-1 text-xs text-muted-foreground">
                  <Icon name="MapPin" size={14} />
                  {opportunity?.location}
                </span>
                <span className="flex items-center gap-1 text-xs text-muted-foreground">
                  <Icon name="Clock" size={14} />
                  {opportunity?.commitment}
                </span>
              </div>
              <div className="flex flex-wrap gap-2">
                {opportunity?.skills?.slice(0, 3).map((skill, index) => (
                  <span
                    key={index}
                    className={`text-xs font-medium px-2 py-1 rounded-full ${getSkillBadgeColor(skill)}`}
                  >
                    {skill}
                  </span>
                ))}
                {(opportunity?.skills?.length > 3) && (
                  <span className="text-xs text-muted-foreground self-center">
                    +{opportunity.skills.length - 3}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OpportunityCard;